export default "__VITE_ASSET__6LSWowIj__"